import { c as _c } from "react/compiler-runtime";
import { FlexColumn } from "@opensea/ui-kit";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { useIsAbstractWalletAccount } from "../../../hooks/useIsAbstractWalletAccount";
import { EMBEDDED_WALLET_CONNECTOR_ID } from "../../../lib/wagmi";
import { useAccount, useConnect } from "../../../polychain/hooks";
import { WalletRejectedError } from "../../../polychain/lib/errors";
import { FlowActions, FlowState } from "../../../stores/flowStore";
import { useErrors } from "../../hooks/useErrors";
import { CheckoutPaymentStep } from "../CheckoutPaymentStep/CheckoutPaymentStep";
import { PaymentMethodStep } from "../PaymentMethodStep";
import { useCardCheckout } from "../use-card-checkout";
export const CheckoutPaymentSection = t0 => {
  const $ = _c(35);
  const {
    timeline,
    cardSupported,
    currencySelector,
    hidePaymentMethod
  } = t0;
  const t = useTranslations("wallet.CheckoutPaymentSection");
  const {
    flow
  } = useSnapshot(FlowState);
  const checkoutFlow = flow?.type === "checkout" ? flow : undefined;
  const cardCheckout = useCardCheckout();
  const {
    connectorId
  } = useAccount();
  const [paymentMethod, setPaymentMethod] = useState(checkoutFlow?.paymentMethod ?? (connectorId ? `wallet-${connectorId}` : undefined));
  const [paymentStep, setPaymentStep] = useState(hidePaymentMethod || paymentMethod ? "payment" : "payment-method");
  let t1;
  let t2;
  if ($[0] !== paymentMethod) {
    t1 = () => {
      FlowActions.setFlowField("paymentMethod", paymentMethod);
    };
    t2 = [paymentMethod];
    $[0] = paymentMethod;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const {
    setWalletError,
    clearErrors
  } = useErrors();
  const {
    isConnecting,
    connect,
    getConnectorStrict
  } = useConnect();
  let t3;
  if ($[3] !== cardCheckout || $[4] !== clearErrors || $[5] !== connect || $[6] !== getConnectorStrict || $[7] !== isConnecting || $[8] !== paymentMethod || $[9] !== setWalletError) {
    t3 = async () => {
      if (paymentMethod === "card") {
        cardCheckout();
        return;
      }
      const connectorId_0 = paymentMethod?.slice(7);
      if (!connectorId_0) {
        return;
      }
      if (connectorId_0 === EMBEDDED_WALLET_CONNECTOR_ID) {
        const embeddedWalletConnector = getConnectorStrict(EMBEDDED_WALLET_CONNECTOR_ID);
        if (embeddedWalletConnector.isConnected()) {
          await connect(embeddedWalletConnector);
        }
        setPaymentStep("payment");
        return;
      }
      const connector = getConnectorStrict(connectorId_0);
      if (isConnecting) {
        return;
      }
      clearErrors();
      ;
      try {
        await connect(connector);
        setPaymentStep("payment");
      } catch (t4) {
        const error = t4;
        if (error instanceof WalletRejectedError) {
          setWalletError("Rejected");
        } else {
          setWalletError("Error");
        }
      }
    };
    $[3] = cardCheckout;
    $[4] = clearErrors;
    $[5] = connect;
    $[6] = getConnectorStrict;
    $[7] = isConnecting;
    $[8] = paymentMethod;
    $[9] = setWalletError;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const onProceedToPayment = t3;
  const isAbstractWallet = useIsAbstractWalletAccount();
  let t4;
  bb0: {
    if (checkoutFlow?.type !== "checkout") {
      let t5;
      if ($[11] !== t) {
        t5 = t("unsupportedFlow");
        $[11] = t;
        $[12] = t5;
      } else {
        t5 = $[12];
      }
      t4 = t5;
      break bb0;
    }
    if (checkoutFlow.items.length > 1) {
      let t5;
      if ($[13] !== t) {
        t5 = t("unsupportedItemCount");
        $[13] = t;
        $[14] = t5;
      } else {
        t5 = $[14];
      }
      t4 = t5;
      break bb0;
    }
    if (!cardSupported) {
      let t5;
      if ($[15] !== t) {
        t5 = t("unsupportedQuote");
        $[15] = t;
        $[16] = t5;
      } else {
        t5 = $[16];
      }
      t4 = t5;
      break bb0;
    }
    if (isAbstractWallet && checkoutFlow.items.some(_temp)) {
      let t5;
      if ($[17] !== t) {
        t5 = t("unsupportedAbstractWallet");
        $[17] = t;
        $[18] = t5;
      } else {
        t5 = $[18];
      }
      t4 = t5;
      break bb0;
    }
    t4 = undefined;
  }
  const cardDisabledReason = t4;
  let t5;
  if ($[19] !== cardDisabledReason || $[20] !== hidePaymentMethod || $[21] !== onProceedToPayment || $[22] !== paymentMethod || $[23] !== paymentStep) {
    t5 = !hidePaymentMethod && paymentStep === "payment-method" && <PaymentMethodStep cardDisabledReason={cardDisabledReason} onProceedToPayment={onProceedToPayment} paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod} />;
    $[19] = cardDisabledReason;
    $[20] = hidePaymentMethod;
    $[21] = onProceedToPayment;
    $[22] = paymentMethod;
    $[23] = paymentStep;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== cardDisabledReason || $[26] !== currencySelector || $[27] !== hidePaymentMethod || $[28] !== paymentMethod || $[29] !== paymentStep || $[30] !== timeline) {
    t6 = paymentStep === "payment" && <CheckoutPaymentStep cardDisabled={Boolean(cardDisabledReason)} currencySelector={currencySelector} hidePaymentMethodOptions={hidePaymentMethod} onChangePaymentMethod={hidePaymentMethod ? undefined : () => setPaymentStep("payment-method")} paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod} timeline={timeline} />;
    $[25] = cardDisabledReason;
    $[26] = currencySelector;
    $[27] = hidePaymentMethod;
    $[28] = paymentMethod;
    $[29] = paymentStep;
    $[30] = timeline;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  let t7;
  if ($[32] !== t5 || $[33] !== t6) {
    t7 = <FlexColumn className="relative w-full min-w-0">{t5}{t6}</FlexColumn>;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  return t7;
};
function _temp(item) {
  return item.chain.identifier !== "abstract";
}